<template>
  <div>
    <landing-page/>
    <about class="dark-text"/>
    <projects/>
    <contact/>
  </div>
</template>

<script>
import LandingPage from '@/components/LandingPage.vue'
import About from '@/components/About.vue'
import Projects from '@/components/Projects.vue'
import Contact from '@/components/Contact.vue'

export default {
  name: 'home',
  components: {
    LandingPage,
    About,
    Projects,
    Contact
  }
}
</script>
